import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({

	state: {
		auth: {
			user: {},
			token: '',
			authenticated: false,
			permissions: []
		},
		maintenance: true,
		maintenanceUser: false,

		// the following properties are used to display the same search results
		// when a user returns from the structure editor
		searchArguments: null,
		autoSearch: false // flag to indicate if search should be applied when displaying 
							// the MarkingStructureManager view
	},

	mutations: {

		refreshToken(state, token) {
			state.auth.token = token;
		},

		setAutoSearch(state, enabled) {
			state.autoSearch = enabled;
		},

		setMaintenanceMode(state, modeSetting) {
			state.maintenance = modeSetting;
		},

		setMaintenanceUser(state, userSetting) {
			state.maintenanceUser = userSetting;
		},

		setPermissions(state, permissions) {
			state.auth.permissions = permissions;
		},

		setSearchArguments(state, searchArguments) {
			state.searchArguments = searchArguments;
			state.autoSearch = true;
		},

		signIn(state, payload) {
			state.auth.user = payload.user;
			state.auth.token = payload.token;
			state.auth.permissions = [];
			state.auth.authenticated = true;
		},

		signOut(state) {
			state.auth.user = {};
			state.auth.token = '';
			state.auth.permissions = [];
			state.auth.authenticated = false;
		},

		updateUser(state, payload) {
			state.auth.user.firstname = payload.firstname;
			state.auth.user.surname = payload.surname;
			state.auth.user.email = payload.email;
		},

	},

	plugins: [createPersistedState({
		key: 'optimark'
	})]

});

export default store